import { isAfter } from "date-fns";
import parseDate from "./parseDate.function";

type Nullable<T> = T | null | undefined;
type DateOrDateString = Nullable<Date | string>;

/**
 *
 * @param args tuple of DateOrDateString with args[0] = date that should be after and args[1] date to compare against
 * @returns boolean
 */
export default function isDateAfter(...args: [DateOrDateString, DateOrDateString]) {
  const [date1, date2] = args.map((dateOrDateString) =>
    dateOrDateString instanceof Date ? dateOrDateString : parseDate(dateOrDateString),
  );

  const after = !!(date1 && date2 && isAfter(date1, date2));
  return after;
}
